module.exports = __webpack_public_path__ + "static/img/p8.f8cb482.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p8.png
// module id = 250
// module chunks = 1